import cardPlaceholder from './images/card-placeholder.png';
import visa from './images/visa.png';
import mastercard from './images/mastercard.png';
import amex from './images/amex.png';
import discover from './images/discover.png';
import diners from './images/diners.png';
import jcb from './images/jcb.png';

export const getCardPicByType = (cardType: string) => {
    switch (cardType) {
        case 'VISA':
            return visa;
        case 'MASTERCARD':
            return mastercard;
        case 'AMEX':
            return amex;
        case 'DISCOVER':
            return discover;
        case 'DINERS':
            return diners;
        case 'JCB':
            return jcb;
        default:
            return cardPlaceholder;
    }
};
